// extracted by mini-css-extract-plugin
export default {"title":"giveaway-landing-subtitle__title___JDr7i","indent":"giveaway-landing-subtitle__indent___nIX3N"};